<template>
  <div>
    <van-nav-bar fixed title="订单详情" left-arrow @click-left="goBack"/>
    <div class="v_mainBox">
      <van-cell>
        <div class="van-listBox">
          <div class="van-carName"><span class="van-left">车检站：</span>
            <span class="van-right line-height">{{ info.carInspectionStation }}</span>
          </div>
          <p><span class="van-left">订单号：</span><span class="van-right">{{ info.orderId }}</span></p>
          <p><span class="van-left">订单状态：</span><span class="van-right van-color">{{ info.orderStatus }}</span></p>
          <p><span class="van-left">价格：</span><span class="van-right van-color">￥{{ info.totalCost }}</span></p>
          <p><span class="van-left">车牌号：</span><span
              class="van-right">{{ info.carInspectionVehicleLicenseEntity.plateNo }}</span></p>
          <p><span class="van-left">车检方式：</span><span class="van-right">{{ info.reservationType }}</span></p>
          <p><span class="van-left">车辆标识：</span><span class="van-right">{{
              info.carInspectionVehicleLicenseEntity.vin
            }}</span></p>
          <p><span class="van-left">检测日期：</span><span class="van-right">{{ info.appointment }}</span></p>
          <p><span class="van-left">下单时间：</span><span class="van-right">{{ info.createTime }}</span></p>

          <p v-if="info.userRemark != null"><span class="van-left">订单备注：</span><span class="van-right">{{ info.userRemark }}</span></p>
          <p v-if="info.remark != null"><span class="van-left">系统提示：</span><span class="van-right">{{ info.remark }}</span></p>

          <p class="van-linH" @click="goTencentMap"><span class="van-left">地址：</span>
            <span class="van-right line-height">{{ info.address }} <i
                class="van-icon van-icon-location-o address-icon"></i></span>
          </p>

          <div class="van-zj">
            <div class="van-title">行车证正照</div>
            <van-image :src="baseApi + '/file/' + info.carInspectionVehicleLicenseEntity.vehicleLicenseImg"
                       @click="onChange(baseApi + '/file/' + info.carInspectionVehicleLicenseEntity.vehicleLicenseImg)"/>
          </div>
          <div class="van-zj">
            <div class="van-title">行车证副照</div>
            <van-image :src="baseApi + '/file/' + info.carInspectionVehicleLicenseEntity.vehicleLicenseImgBack"
                       @click="onChange(baseApi + '/file/' + info.carInspectionVehicleLicenseEntity.vehicleLicenseImgBack)"/>
          </div>
          <div class="van-zj">
            <div class="van-title">保险单照</div>
            <van-image :src="baseApi + '/file/' + info.carInspectionVehicleLicenseEntity.compulsoryInsuranceImg"
                       @click="onChange(baseApi + '/file/' + info.carInspectionVehicleLicenseEntity.compulsoryInsuranceImg)">
              <template v-slot:error>暂无保险单照</template>
            </van-image>
          </div>
        </div>
      </van-cell>
      <!-- 提交 -->
      <div style="margin: 16px;">
        <van-button v-if="info.orderStatus === '已取消'" round block type="danger" icon="delete" native-type="submit"
                    @click="onDelete">删除订单
        </van-button>

        <div v-if="info.orderStatus === '待确认'">
          <van-button round block plain icon="replay" color="#1B89FA"
                      @click="cancelOrder">取消预约
          </van-button>
        </div>

        <div v-if="info.orderStatus === '已支付' && showRefundBtn == true" style="display: flex;justify-content: space-between;">
            <van-button round block icon="refund-o" color="#1B89FA"
               @click="refundBtn" :style="{marginRight: '30px'}">申请退单
            </van-button>
          <van-button v-if="isComment === ''" round block  icon="comment-o" type="primary"
                      @click="onRemark">订单备注
          </van-button>
        </div>

        <div v-if="info.orderStatus === '已确认'" style="display: flex;justify-content: space-between;">
          <van-button round block icon="refund-o" color="#1B89FA"
                      @click="onRemark" :style="{marginRight: '30px'}">订单备注
          </van-button>
          <van-button v-if="isComment === ''" round block  icon="comment-o" type="primary"
                      @click="onComment">去评价
          </van-button>
        </div>

        <div v-if="info.orderStatus === '待支付'" style="display: flex;justify-content: space-between;">
          <van-button round block plain icon="replay" color="#1B89FA"
                      @click="cancelOrder" :style="{marginRight: '30px'}">取消预约
          </van-button>
          <van-button round block  icon="after-sale" type="primary"
                      @click="toPay">去支付
          </van-button>
        </div>

        <van-button v-if="info.orderStatus === '申请退单'" round block  icon="comment-o" type="primary"
                    @click="onRemark">订单备注
        </van-button>

      </div>
    </div>
    <van-image-preview v-model="show" :images="images"></van-image-preview>
  </div>
</template>

<script>
import {baseApi} from "@/utils/auth";
import carInspectionOrder from "@/api/carInspectionOrder";
import carInspectionComment from "@/api/carInspectionComment";

export default {
  name: "orderInfor",
  data() {
    return {
      id: null,
      info: {'carInspectionVehicleLicenseEntity': {}},
      show: false,
      index: 0,
      images: [],
      isComment: null,
      baseApi: baseApi(),
      type: '',
      showRefundBtn: false
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getOrderInfo()
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
        return false
      } else {
        window.console.log("2")
        this.$router.push({path: '/order'})
        // this.$router.go(-1)
      }
    },
    /**
     * 获取订单信息
     */
    getOrderInfo() {
      const toast = this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      carInspectionOrder.byId({id: this.id}).then(res => {
        this.info = {}
        this.info = Object.assign({}, res)
        this.type = res.reservationType
        this.getIsComment()
        toast.clear()

        let appointmentDate = new Date(res.appointment) //预约时间
        let nowdate = new Date();
        if(nowdate.getTime() < appointmentDate.getTime()){
          this.showRefundBtn = true
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    },
    /**
     * 获取是否已经评论
     */
    getIsComment() {
      this.isComment = null
      carInspectionComment.isComment({'stationId': this.info.stationId, 'orderId': this.info.id}).then(res => {
        this.isComment = res
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
      })
    },
    /**
     * 取消订单
     */
    cancelOrder() {
      this.$dialog.confirm({
        title: '是否取消该预约？',
        message: '是否取消该预约，此操作不可撤销！',
      }).then(() => {
        carInspectionOrder.edit({'id': this.info.id, 'orderStatus': '已取消'}).then(res => {
          // eslint-disable-next-line no-console
          console.log(res)
          this.info.orderStatus = '已取消'
          this.$notify({type: 'success', message: '取消成功'});
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err.data.message)
        })
      }).catch(() => {
        // on cancel
      })
    },
    /**
     * 删除订单
     */
    onDelete() {
      this.$dialog.confirm({
        title: '是否删除？',
        message: '是否删除该订单，此操作不可撤销！',
      }).then(() => {
        carInspectionOrder.del({'id': this.info.id}).then(res => {
          // eslint-disable-next-line no-console
          console.log(res)
          this.$notify({type: 'success', message: '删除成功\n两秒后跳转'});
          setTimeout(() => {
            this.$router.go(-1)
          }, 2000);
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err.data.message)
        })
      }).catch(() => {
        // on cancel
      })
    },
    /**
     * 评论
     */
    onComment() {
      this.$router.push({
        path: '/comments',
        query: {
          stationName: this.info.carInspectionStation,
          stationId: this.info.stationId,
          orderId: this.info.id
        }
      })
    },
    onRemark(){
      this.$router.push({
        path: '/remark',
        query: {
          orderId: this.info.id,
          userRemark: this.info.userRemark
        }
      })
    },
    goTencentMap() {
      const url = 'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + this.info.lat + ',' + this.info.lng + ';title:' + this.info.carInspectionStation + ';addr:' + this.info.address + '&key=KE2BZ-5CY6W-VRMRT-OCZ63-A7M7O-D4FM2&referer=myapp'
      window.open(url, "_self");
    },
    onChange(img) {
      this.show = true
      this.images[0] = img
    },
    //申请退单
    refundBtn(){
      let vehicleFee = this.info.vehicleFee
      let doorServiceFee = this.info.doorServiceFee
      let inspectionServiceFee = this.info.inspectionServiceFee
      let msg = ''
      if(this.type == '到站代检'){
        msg = '申请退单通过后系统将会自动收取您代检费'+inspectionServiceFee+'元的'+this.info.inspectionServiceDiscount+'%退检手续费，车辆检测费'+vehicleFee+'元全额退款。';
      }else if(this.type == '预约检车'){
        let platFee = this.info.platFee
        if(null == platFee){
          msg = '车辆检测费'+vehicleFee+'元全额退款。';
        }else{
          msg = '申请退单通过后系统将会自动收取您平台预约服务费'+platFee+'元，车辆检测费'+vehicleFee+'元全额退款。';
        }
      }else if(this.type == '上门代检'){
        msg = '申请退单通过后系统将会自动收取您取还车费'+doorServiceFee+'元，代检费'+inspectionServiceFee+'元的'+this.info.inspectionServiceDiscount+'%退检手续费，车辆检测费'+vehicleFee+'元全额退款。';
      }

      this.$dialog.confirm({
        title: '确定要申请退单吗？',
        message: msg,
        messageAlign: 'left'
      }).then(() => {
        const toast = this.$toast.loading({
          message: '申请中...',
          forbidClick: true,
        });
        carInspectionOrder.edit({'id': this.info.id, 'orderStatus': "申请退单"}).then(res => {
          // eslint-disable-next-line no-console
          console.log(res)
          toast.clear()
          this.info.orderStatus = '申请退单'
          this.$notify({type: 'success', message: '申请退单成功'});
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err.data.message)
        })
      }).catch(() => {
        // on cancel
      })
    },
    //去支付
    toPay(){
      const toast = this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
      });
      let param = {}
      param.orderId = this.info.orderId
      param.miniprogram = false
      if (window.__wxjs_environment === 'miniprogram'){
        param.miniprogram = true
      }
      carInspectionOrder.toPay(param).then(res => {
        toast.clear()
        // eslint-disable-next-line no-console
        window.location.href = res
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err.data.message)
        toast.clear()
      })
    }

  }
}
</script>
<style scoped>
.v_mainBox {
  width: 100%;
  padding-top: 45px;
}

.van-listBox {
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
}

.van-listBox p {
  margin: 0;
  padding: 0 15px;
  height: 45px;
  line-height: 45px;
  border-bottom: 5px solid #eee;
}

.van-listBox p .van-left {
  width: 28%;
  float: left;
  text-align: left;
}

.van-listBox p .van-right {
  width: 72%;
  float: right;
  /*text-align: right;*/
}

.van-color {
  color: #3778d0
}

.van-pay {
  color: #3778d0;
  font-weight: bold;
  font-size: 15px;
  text-align: right;
}

.van-cell {
  padding: 0 !important;
  height: auto !important;
}

.van-cell::after {
  border: none;
}

/*证件*/
.van-zj {
  height: auto;
  width: 100%;
  display: block;
  overflow: hidden;
  border-bottom: 5px solid #eee;
}

.van-zj .van-title {
  width: 90%;
  margin: auto;
  height: 35px;
  line-height: 40px;
}

.van-image {
  width: 50%;
  margin: 10px 0 0 22%;
  height: auto;
}

.van-button--info {
  color: #fff !important;
  background-color: #3778d0 !important;
  border: 1px solid #3778d0 !important;
}


.van-carName {
  min-height: 30px !important;
  line-height: 25px !important;
  text-align: left !important;
  padding: 5px 15px !important;
  overflow: hidden;
  border-bottom: 5px solid #eee;
}

.van-carName .van-left {
  width: 28%;
  float: left;
  text-align: left;
}

.van-carName .van-right {
  width: 72%;
  float: right;
}


.van-linH {
  min-height: 30px !important;
  line-height: 25px !important;
  text-align: left !important;
  padding: 10px 15px !important;
  overflow: hidden;
}

.line-height {
  text-align: left !important;
}

.van-uploader__wrapper {
  cursor: pointer;
  width: 30% !important;
  height: 80px !important;
  display: block;
  overflow: hidden;
}

.van-uploader__preview img {
  height: 100%
}

.van-r {
  text-align: right
}
</style>
